export default __webpack_public_path__ + "static/media/Note.ab77839a.svg";